export default __webpack_public_path__ + "static/media/animation.77ed68bc.gif";